import React from "react";
import Icon from "@ant-design/icons";
import { IIconProps } from "typings/icons.types";

const WatchSvg = (props: IIconProps) => {
  const { width = 16, height = 16 } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.99992 14.6666C4.31792 14.6666 1.33325 11.6819 1.33325 7.99992C1.33325 4.31792 4.31792 1.33325 7.99992 1.33325C11.6819 1.33325 14.6666 4.31792 14.6666
      7.99992C14.6666 11.6819 11.6819 14.6666 7.99992 14.6666ZM7.99992 13.3333C9.41441 13.3333 10.771 12.7713 11.7712 11.7712C12.7713 10.771 13.3333 9.41441 13.3333
      7.99992C13.3333 6.58543 12.7713 5.22888 11.7712 4.22868C10.771 3.22849 9.41441 2.66659 7.99992 2.66659C6.58543 2.66659 5.22888 3.22849 4.22868 4.22868C3.22849
      5.22888 2.66659 6.58543 2.66659 7.99992C2.66659 9.41441 3.22849 10.771 4.22868 11.7712C5.22888 12.7713 6.58543 13.3333 7.99992 13.3333ZM8.66659
      7.99992H11.3333V9.33325H7.33325V4.66659H8.66659V7.99992Z"
        fill="#0E0E0E"
      />
    </svg>
  );
};

const Watch = (props: IIconProps) => <Icon component={() => <WatchSvg {...props} />} {...props} />;

export default Watch;
